import { NotFound } from 'component/errors/not-found';
import { questionModuleQuery, useModule } from 'system/structure-modules';
import { useEnabledFeatures } from 'util/features-hooks';

export default function SpaceConversationHelperAdminScreen() {
    const { ConversationHelperAdminScreen } = useModule(questionModuleQuery);
    const { conversationhelper } = useEnabledFeatures();
    if (!conversationhelper) {
        return <NotFound />;
    }

    return <ConversationHelperAdminScreen />;
}
